const createConsts = (module, submodule, ...actions) =>
  actions.reduce((acc, c) => {
    Object.defineProperty(acc, c, {
      value: `${module}/${submodule}/${c}`,
      enumerable: true,
    });
    return acc;
  }, {});

export default createConsts;



// WEBPACK FOOTER //
// ./src/utils/redux/consts.js